import {
	Component,
	EventEmitter,
	Input,
	Output,
	ViewChild,
} from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';

export interface MapPin {
	lat: number;
	lng: number;
}

@Component({
	selector: 'app-map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.css'],
	imports: [GoogleMap, MapMarker],
})
export class MapComponent {
	@ViewChild(GoogleMap, { static: false }) map?: GoogleMap;
	@ViewChild(MapInfoWindow, { static: false }) info?: MapInfoWindow;
	@ViewChild(MapMarker, { static: false }) mapMarker?: MapMarker;

	@Input() markers: MarkerOnMap[] = [];
	@Input() mapCenter: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
	@Output() currentLocation: EventEmitter<GeolocationPosition> =
		new EventEmitter();

	zoom = 10;
	mapOptions: google.maps.MapOptions = {
		zoomControl: false,
		scrollwheel: true,
		disableDoubleClickZoom: true,
	};
}

export type MarkerOnMap = {
	position: google.maps.LatLngLiteral;
};
